<template>
  <ThemedSelector
    v-model="selectedLegModel"
    :items="voyageLegs"
    :item-text="displayLeg"
    solo
    flat
    hide-details
    color="primary"
    item-color="primary"
    return-object
    style="max-width: 420px; font-size: 15px"
    class="my-auto mx-2"
    :menu-props="{
      bottom: true,
      offsetY: true,
      maxHeight: 300,
      closeOnContentClick: true,
      transition: 'slide-y-transition',
      eager: true,
    }"
    @change="onLegChanged"
  />
</template>

<script>
import { mapState } from "vuex";
import ThemedSelector from "@/core/ThemedSelector.vue";
export default {
  name: "SelectVoyageLegComponent",
  components: {
    ThemedSelector,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("vesselInformation", ["voyageLegs", "selectedLeg"]),
    selectedLegModel: {
      get() {
        return this.selectedLeg;
      },
      set(value) {
        this.$store.commit("vesselInformation/SET_SELECTED_LEG", value, {
          root: true,
        });
      },
    },
  },
  methods: {
    displayLeg(leg) {
      const startDate = leg.startDate.substring(0, 11).replace("T", " ");
      const stopDate = leg.stopDate.substring(0, 11).replace("T", " ");

      return `Voyage ${leg.currentNum}, leg ${leg.currentLeg}  from ${startDate} to ${stopDate}`;
    },
    onLegChanged() {
      const vesselName = this.$route.params.vessel;
      this.$store.dispatch("vesselInformation/fetchVoyageData", vesselName);
    },
  },
};
</script>
